// Runtime config injected by the container (public/config.js). The runtime value
// wins; an empty or unsubstituted "${...}" placeholder is ignored so the
// build-time VUE_APP_* value is used as a fallback.
const runtimeConfig = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}
function runtimeOr(value, fallback) {
  if (typeof value === 'string' && value && !value.startsWith('${')) return value
  return fallback
}

export const FRONT_URL = process.env.VUE_APP_FRONT_URL
export const DOMAIN = process.env.VUE_APP_DOMAIN
export const API_URL = runtimeOr(runtimeConfig.API_URL, process.env.VUE_APP_API_URL)
export const NODE_ENV = process.env.VUE_APP_ENV
export const API_VERSION = 'v1'
export const CLIENT_APP = 'AtlanticAdmin'
export const FORMAT_DATE = 'DD/MM/YYYY'
export const FORMAT_DATETIME_BACKEND = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ'
export const DEFAULT_DATE = 'YYYY-MM-DD'
export const DEFAULT_DATETIME = 'YYYY-MM-DDTHH:mm:ssZ'
export const FORMAT_DATETIME = 'MM/DD/YYYY HH:mm'
